/**
 * Represents the workflow status of a submission task.
 */
export enum SubmissionTaskStatusModel {
	/**
	 * The task has not been started.
	 */
	NotStarted = 1,
	/**
	 * The task is in progress.
	 */
	InProgress = 2,
	/**
	 * The task is blocked or escalated for development support.
	 */
	DevSupport = 3,
	/**
	 * The task is blocked or escalated for account executive support.
	 */
	AeSupport = 4,
	/**
	 * The task is ready for submission.
	 */
	ReadyForSubmission = 5,
	/**
	 * The customer is no longer expected to submit this period.
	 */
	NoLongerExpected = 6
}
